import { render, staticRenderFns } from "./EmailCreation.vue?vue&type=template&id=0220ac76"
import script from "./EmailCreation.vue?vue&type=script&lang=js"
export * from "./EmailCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports